<template>
  <div class="index">
 
  <div style="margin-bottom: 10px;">
  <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg" >
  <el-breadcrumb-item :to="{ path: '/admin' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>代理统计</el-breadcrumb-item>
  
  
</el-breadcrumb>
</div>
 
 <el-card>
	<el-row>
		<el-col :span="1" style="width: 10px;"  >
			<span style="background-color: #409eff; width: 2px; height: 20px; display: block; "></span>
		</el-col>
		<el-col :span="10">
			代理业绩
		</el-col>
	</el-row>
</el-card>
   
  </div>
</template>

<script>
export default {
    data() {
      return {
		form:{
			name:"",
			delivery:""
		},
        activeName: 'first'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

 
  
 

   .box-card{
    padding: 18px 0;
    margin-top: 20px;
    margin-right: 10px;
  }
 
</style>
